module.exports = __webpack_public_path__ + "static/media/fieldhockey.a9924134.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/fieldhockey.svg
// module id = 375
// module chunks = 7